export default "__VITE_ASSET__CPqV1caN__"